import { render, staticRenderFns } from "./CustomsDetail.vue?vue&type=template&id=4b57a5b3&scoped=true"
import script from "./CustomsDetail.vue?vue&type=script&lang=js"
export * from "./CustomsDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomsDetail.vue?vue&type=style&index=0&id=4b57a5b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b57a5b3",
  null
  
)

export default component.exports